//关于望潮页面
<template>
  <el-row type="flex" justify="center" class="introduce">
    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="introduce_top">
      <!-- <img src="@/assets/img/introduce/introduce_top.png" /> -->
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15" data-aos="fade-right" class="top_title">
          <h3>关于我们</h3>
          <span>About US</span>
          <!-- <p>融合AI、大数据、云服务技术的智能服务商</p> -->
        </el-col>
      </el-row>
    </el-col>

    <!-- <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15" id="anchor" class="introduce_center">
      <div data-aos="fade-up" class="center_title">
        <span>公司简介</span>
        <p>融合AI、大数据、云服务技术的智能服务商</p>
      </div>
      <div data-aos="fade-up" class="center_body">
        <img src="@/assets/img/introduce/introduce_center.png" />
        <div class="body_right">
          <p>望潮智能隶属于和君纵达集团，是融合新型互联网技术的智能服务商。望潮智能致力于将企业同客户互动的全过程数字化、智能化，帮助企业提升客户满意度，实现可持续的业绩增长。</p>
          <p>自创立以来，望潮智能一直坚持初心，不断将新型互联网技术应用到贷后管理领域的同时，也努力提升在传统业务流程（销售、市场、客户服务）的深度理解和软件服务的专业性，并获得了多家企业的青睐。</p>
          <p>展望未来，望潮智能将继续深耕企业级服务，持续专注于贷后管理领域，在不断优化企业业务流程和用户体验的同时，进一步利用新型互联网技术，为用户实现企业、客户、合作伙伴与产品之间的无缝连接与交互，帮助企业构建真正以客户为中心的核心竞争力，重塑企业与客户的连接，成就卓越客户关系。</p>
        </div>
      </div>
    </el-col> -->

    <div class="introduce_bottom">
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15" style="margin:0 2em;">
        <div data-aos="fade-up" class="bottom_top">
          <h4>经验丰富的运营团队，提供业务支持</h4>
          <!-- <p>多场景运营服务的业务能力</p> -->
        </div>
        <div class="bottom_body">
          <div data-aos="flip-left" class="bottom_item" v-for="(item,index) in bottomData" :key="index">
            <img :src="item.imgUrl" />
            <p>{{item.text}}</p>
          </div>
        </div>
        </el-col>
      </el-row>
    </div>
  </el-row>
</template>

<script>
export default {
  name: "introduce",
  data() {
    return {
      // 专业化运营数据
      bottomData: [
        {
          imgUrl: require("@/assets/img/introduce/introduce_bottom1.png"),
          text: "经验丰富的话术设计师团队"
        },
        {
          imgUrl: require("@/assets/img/introduce/introduce_bottom2.png"),
          text: "以节约人力为目标，提供定制化的解决方案"
        },
        {
          imgUrl: require("@/assets/img/introduce/introduce_bottom3.png"),
          text: "把握运营关键点，促进指标达成"
        },
        {
          imgUrl: require("@/assets/img/introduce/introduce_bottom4.png"),
          text: "资深的技术团队，为项目运营保驾护航"
        },
        {
          imgUrl: require("@/assets/img/introduce/introduce_bottom5.png"),
          text: "根据不同产品、场景制定适合的策略"
        },
        {
          imgUrl: require("@/assets/img/introduce/introduce_bottom6.png"),
          text:
            "以客户为中心的支持服务"
        }
      ],
      anchorFlag: false
    };
  },
  created() {
    if (this.$anchorFlag || this.$store.state.anchorFlag) {
      window.scrollTo(0, 800);
      this.$anchorFlag = false;
      this.$store.state.anchorFlag = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 1300px) {
  .introduce_top {
    width: 1300px !important;
    height: 500px !important;
    background-size: 1300px 500px;
    background-position: center;
  }
}
@media only screen and (max-width: 1600px) and (min-width: 1300px) {
  .introduce_top {
    width: 1600px !important;
    height: 600px !important;
    background-size: 1600px 600px;
    background-position: center;
  }
}
.introduce {
  flex-flow: row wrap;
  .introduce_top {
    height: 700px;
    width: 100%;
    background: url("../assets/img/introduce/introduce_top.png") no-repeat
      center;
    border-top: 1px solid white;
    img {
      position: absolute;
      z-index: -10;
      height: 35rem;
      width: 100%;
    }
    .top_title {
      width: 32rem;
      height: 10rem;
      margin: 14rem 0rem 0rem 0rem;
      color: white;

      h3 {
        font-size: 2.4rem;
        margin-bottom: 1.9rem;
      }
      span {
        font-size: 1.5rem;
      }
      p {
        margin-top: 3.85rem;
        font-size: 0.8rem;
      }
    }
    @media only screen and (max-width: 1300px){
      height: 300px!important;
      background-size: auto 300px!important;
    }
  }

  .introduce_center {
    // height: 43.3rem;
    margin: 0 2em;
    .center_title {
      // width: 60rem;
      height: 4.6rem;
      margin: 6.15rem auto 4.55rem;
      text-align: center;
      span {
        font-size: 1.8rem;
      }
      p {
        font-size: 0.9rem;
        margin-top: 1.95rem;
      }
    }
    .center_body {
      // width: 60rem;
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      img {
        float: left;
        width: 29.8rem;
        height: 21.7rem;
      }
      .body_right {
        float: left;
        // width: 24.8rem;
        // height: 21.75rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 4rem;
        margin-bottom: 6rem;
        font-size: 0.8rem;
        line-height: 1.5rem;
      }
    }
    @media only screen and (max-width: 997px) {
      .center_body{
        img{
          width: 10rem!important;
          height: 9rem!important;
        }
        .body_right{
          line-height: 2.5rem;
        }
      }
    }
  }

  .introduce_bottom {
    width: 100%;
    // height: 60rem;
    padding-bottom: 6rem;
    background: rgba(247, 248, 252, 1);
    border-top: 1px solid white;

    .bottom_top {
      height: 4.6rem;
      text-align: center;
      margin: 6.3rem auto 4.95rem;
      h4 {
        margin-bottom: 1.95rem;
        font-size: 1.8rem;
      }
      p {
        font-size: 0.9rem;
      }
    }
    .bottom_body {
      // width: 60rem;
      // height: 37.8rem;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .bottom_item {
        width: 17.5rem;
        min-height: 17.5rem;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 20px 0px rgba(3, 3, 3, 0.2);
        margin-bottom: 2.5rem;
        img {
          width: 3rem;
          height: 3rem;
          display: block;
          margin: 3rem auto 2.05rem;
        }
        p {
          width: 13rem;
          font-size: 1rem;
          line-height: 1.8rem;
          margin: 0 auto;
        }
      }
      @media only screen and (max-width: 997px){
        .bottom_item{
          p{
            line-height: 2rem;
            padding-bottom: 2rem;
          }
        }
      }
    }
  }
}
</style>